<mat-card class="w-full max-w-[50rem]">
  <mat-card-content class="flex flex-col gap-y-3">
    <div class="text-headline-large">Details</div>
    <div class="text-body-large mb-8">Your e-mail was verified successfully! Please tell us a little more about you:
    </div>
    @let isSm = viewportSelectors.isSm | select;
    @let defaultRowCss = 'flex flex-row gap-x-3 md:gap-x-4 w-full';
    @let collapsingRowCss = 'flex flex-col md:flex-row gap-x-3 md:gap-x-4 w-full';
    <div [class]="defaultRowCss">
      <mx-input-form-field fieldName="firstName" class="basis-1/2 md:basis-2/5" [formGroup]="detailsForm"/>
      <mx-input-form-field fieldName="lastName" class="basis-1/2 md:basis-2/5" [formGroup]="detailsForm"/>
      <mx-input-form-field fieldName="suffix" class="basis-1/5 hidden md:block" [formGroup]="detailsForm"/>
    </div>
    <div [class]="defaultRowCss">
      <mx-input-form-field fieldName="address" overrideLabel="Street Address" class="basis-1/2"
                           [formGroup]="detailsForm"/>
      <mx-input-form-field fieldName="address2" class="basis-1/2" [formGroup]="detailsForm"
                           [overrideLabel]="isSm ? 'Apt, Ste, Unit...' : 'Apartment, Suite, Unit, etc.'"/>
    </div>
    <div [class]="collapsingRowCss">
      <mx-input-form-field fieldName="city" class="w-full md:basis-3/5" [formGroup]="detailsForm"/>
      <div [class]="defaultRowCss">
        <mx-select-form-field fieldName="state" class="basis-1/2 md:basis-1/3" [formGroup]="detailsForm"
                              [options]="STATE_SELECT" [includeUndefinedOption]="false"/>
        <mx-input-form-field fieldName="zip" overrideLabel="Zip Code" class="basis-1/2 md:basis-2/3"
                             [formGroup]="detailsForm"/>
      </div>
    </div>
    <div [class]="collapsingRowCss">
      <mx-select-form-field fieldName="branchId" overrideLabel="Pickup Location" class="w-full md:basis-2/3"
                            [formGroup]="detailsForm"
                            [options]="branchSelectors.pickupLocationsSelectOptions | select:[]"
                            [includeUndefinedOption]="false"/>
      <mx-date-form-field fieldName="dateOfBirth" overrideLabel="Date of Birth" class="w-full md:basis-1/3"
                          [formGroup]="detailsForm"/>
    </div>
    <div class="flex flex-row justify-end">
      <mx-filled-button label="Submit" [enabled]="detailsForm.valid" (click)="onClickNext()"
                        class="w-full md:w-[15rem]"/>
    </div>
  </mat-card-content>
</mat-card>
<div class="max-w-[33%] overflow-hidden ml-4">
  <img ngSrc="/assets/registration/create-password.png" priority width="276" height="540" alt=""
       class="hidden md:flex md:max-w-[10.75rem] lg:max-w-[17.25rem]"/>
</div>
